import { Beer } from "../../data/types";
import "./BeerInfo.scss";
// import { FaUntappd } from "react-icons/fa6";

interface BeerInfoProps {
  beer: Beer; // Lägg till en lista med ölsorter som kommer skickas in
  onClose: () => void; // En funktion för att stänga popupen
}

const BeerInfo: React.FC<BeerInfoProps> = ({ beer, onClose }) => {
  // Stänger popupen när användaren klickar utanför
  const handleClosePopup = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="beer-info" onClick={handleClosePopup}>
      <div className="beer-info__content">
        <img className="beer-info__image" src={beer.image} alt={beer.name} />

        <div className="beer-info__text">
          <div className="beer-info__section">
            <h2 className="beer-info__name">{beer.name}</h2>
            <div className="beer-info__details">
              <p className="beer-info__type">{beer?.type}</p>
              <p className="beer-info__abv">{beer?.abv}%</p>
            </div>
          </div>

          <div className="beer-info__section beer-info__section--text">
            <h3 className="beer-info__subheading">Description</h3>
            <p className="beer-info__paragraph">{beer.description}</p>
          </div>

          <div className="beer-info__section beer-info__section--text">
            <h3 className="beer-info__subheading">Systembolaget</h3>
            <p className="beer-info__paragraph">{beer.availability}</p>
          </div>

          <div className="beer-info__section beer-info__section--text">
            <h3 className="beer-info__subheading">Fun Fact</h3>
            <p className="beer-info__paragraph">{beer.funFact}</p>
          </div>

          <div className="beer-info__untappd">
            <a href={beer.untappdLink} target="_blank" rel="noreferrer">
              <img
                className="beer-info__untappd-logo"
                src="/untappd.svg"
                alt="Untappd logo"
              />
            </a>
          </div>
        </div>
      </div>
      <button className="beer-info__close-btn" onClick={onClose}>
        <img
          className="beer-info__close-icon"
          src="/cancel.svg"
          alt="Cancel icon"
        />
      </button>
    </div>
  );
};

export default BeerInfo;
